import { z } from 'zod'
import { oc } from '@orpc/contract'
import { DISCOVERY_KINDS, LAB_VENDORS } from '../facility-discovery-shared.schema'

// Exported (not inlined into .input()) so the contract spec imports a plain
// zod schema instead of reaching into the builder — see
// facility-discovery-adopt.contract.spec.ts (same pattern as the search contract).
export const facilityDiscoveryAdoptInputSchema = z
  .object({
    placeId: z.string().min(1).max(300),
    fax: z
      .string()
      .trim()
      .max(30)
      .refine((v) => /^\D*(?:1\D*)?(?:\d\D*){10}$/.test(v), 'fax must be a 10-digit US number')
      .optional(),
    kind: z.enum(DISCOVERY_KINDS).default('radiology'),
    // Adopt needs the vendor itself: it decides the minted org's `partOf`, its
    // name prefix, and which seeded PSCs the place may be matched against.
    vendor: z.enum(LAB_VENDORS).optional(),
  })
  .refine((v) => v.kind !== 'lab' || Boolean(v.vendor), {
    message: 'vendor is required when kind is lab',
  })

export const facilityDiscoveryAdopt = oc
  .route({ method: 'POST', path: '/v2/facility-discovery/adopt' })
  .input(facilityDiscoveryAdoptInputSchema)
  .output(z.object({ organizationId: z.string(), fax: z.string().optional() }))
